import React from 'react';

interface SubmittingOverlayProps {
  visible: boolean;
}

/**
 * pre-jobID 区間（POST /jobs のアップロード中）に全画面に表示する薄オーバーレイ。
 * 状態の可視化＋ユーザーへの reload 抑止メッセージを担う。
 * useBeforeUnloadGuard と併用して使う (設計 §4.1)。
 */
const SubmittingOverlay: React.FC<SubmittingOverlayProps> = ({ visible }) => {
  if (!visible) return null;
  return (
    <div
      role="status"
      aria-live="assertive"
      aria-label="ジョブ投入中"
      className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center px-4"
    >
      <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full flex flex-col items-center gap-3">
        <svg
          className="w-10 h-10 animate-spin text-orange-500"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
        <p className="text-base font-bold text-gray-800">ジョブを投入中…</p>
        <p className="text-xs text-gray-600 text-center leading-relaxed">
          ブラウザのリロードや戻る・閉じる操作は行わないでください
        </p>
      </div>
    </div>
  );
};

export default SubmittingOverlay;
